.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.product-main {
  background-color: #ffffff;
}

@media screen and (min-width: 980px) {
  .product-main {
    padding: 0 10px;
    padding-bottom: 49px;
    margin-bottom: 8px;
  }
}

@media screen and (max-width: 979px) {
  .product-main {
    padding-bottom: 16px;
    margin-bottom: 20px;
    box-shadow: 0 0 2px 0 rgba(51, 51, 51, 0.05), 0 2px 5px 0 rgba(51, 51, 51, 0.15);
  }
}

.product-main__info-container {
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .product-main__info-container {
    flex: 1 1 auto;
  }
}

@media screen and (max-width: 979px) {
  .product-main__info-container {
    width: 100%;
  }
}

.product-main__cta-area {
  width: 100%;
}

@media screen and (max-width: 979px) {
  .product-main__cta-area {
    margin: 0 auto;
  }
}

@media screen and (max-width: 979px) {
  .product-main__section:not(.product-main__section--cta-area) {
    padding: 0 16px;
  }
}

.product-main__section--main-area + .product-main__section--links-area, .product-main__section--main-area + .product-main__section--cta-area.product-main__section--hidden + .product-main__section--links-area {
  border-top: 1px solid #e7e6e6;
}

.product-main__section--hidden {
  display: none;
}

@media screen and (max-width: 979px) {
  .product-main__media-gallery {
    width: 100%;
    padding: 0 16px;
  }
}

@media screen and (min-width: 980px) {
  .product-main__media-gallery {
    align-self: flex-start;
  }
}

@media screen and (min-width: 980px) {
  .product-main__media-gallery.product-main__media-gallery--sticky-to-top, .product-main__media-gallery.product-main__media-gallery--sticky-to-bottom {
    position: sticky;
  }

  .product-main__media-gallery.product-main__media-gallery--sticky-to-top:not(.media-gallery--dialog-open), .product-main__media-gallery.product-main__media-gallery--sticky-to-bottom:not(.media-gallery--dialog-open) {
    z-index: 9;
  }
}

@media screen and (min-width: 980px) {
  .product-main__media-gallery.product-main__media-gallery--sticky-to-top {
    top: 0;
  }
}

@media screen and (min-width: 980px) {
  .product-main__media-gallery.product-main__media-gallery--sticky-to-bottom {
    align-self: flex-end;
    bottom: 0;
  }
}

.product-main__recommendations {
  width: 100%;
  background-color: #F0F1F2;
  padding-bottom: 40px;
}

.product__content {
  display: flex;
  width: 100%;
}

@media screen and (min-width: 980px) {
  .product__content {
    flex-direction: row;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 10px;
  }
}

@media screen and (max-width: 979px) {
  .product__content {
    flex-direction: column;
  }
}

.product__range-link {
  min-height: 29px;
}

@media screen and (min-width: 980px) {
  .product__range-link {
    max-width: 1200px;
    margin: 0 auto;
  }
}

.main-area--no-separator + pes-cta-area-se-container,
.main-area--no-separator + pes-cta-area-apc-container {
  border-top: none;
}